import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import { modal } from 'react-redux-modal';
import { NotificationEmbed } from '@exploreorg/explore-comments';
import {setChannelNavPosition} from '../../actions/nav';
import {authLogout, authLoginUserSuccess, handleConfirmRedirect, disableRegistrationPrompt} from '../../actions/auth';
import {fetchUserFavoritesSuccess} from '../../actions/favorites';
import Cookie from 'js-cookie';
import {
  SearchView,
  LoginModalView,
  SignUpModalView,
  ConfirmAssociationModalView,
  PasswordResetModal,
  WelcomeModal
} from '../../components';
import MediaQuery from 'react-responsive';
import UserMenu from './UserMenu';

import './styles.scss';
import TrackedButton from '../Buttons/TrackedButton';
import { commentsConfig } from '../../utils';
import NotificationSettingsModal from '../Modals/NotificationSettingsModal';

const propTypes = {
  statusText: PropTypes.string,
  userName: PropTypes.string,
  displayName: PropTypes.string,
  sectionName: PropTypes.node,
  profileImage: PropTypes.string,
  isFeatured: PropTypes.bool,
  standalone: PropTypes.bool,
  promptRegistration: PropTypes.bool,
  livecamClicks: PropTypes.number,
};

const defaultProps = {
  sectionName: 'livecams',
  statusText: '',
  userName: '',
  displayName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png',
  standalone: false,
};

const contextTypes = {
  router: PropTypes.object.isRequired
};

class Header extends React.Component {

  constructor(props) {
    super(props);
    this.openLogin = this.openLogin.bind(this);
    this.openSignup = this.openSignup.bind(this);
    this.state = { notificationsModalOpen: false, };
    this.onSideMenuClick = this.onSideMenuClick.bind(this);
    this.handleStorageChange = this.handleStorageChange.bind(this);
    this.launchWelcome = this.launchWelcome.bind(this);
    this.paneDidMount = this.paneDidMount.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount(){
    this.props.dispatch(setChannelNavPosition(this.props.activeChannelId));
  }

  componentDidMount(){
    window.addEventListener('storage', this.handleStorageChange);
    window.addEventListener('openLogin', this.openLogin);
  }

  componentWillUnMount(){
    window.removeEventListener('storage');
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('openLogin', this.openLogin);
  }

  componentWillUpdate(nextProps) {
    if(!nextProps.resetToken && nextProps.resetToken !== this.props.resetToken ) {
      modal.clear();
    }
  }

  componentDidUpdate(){
    if (this.context.router.params.code && this.props.resetToken) {
      modal.clear();
      modal.add(PasswordResetModal, {hideTitleBar:true, size:'medium', id:'password-reset'})
    }

    if (this.props.promptRegistration && this.props.livecamClicks === 1) {
      this.openSignup(new CustomEvent('triggered open'));
      this.props.dispatch(disableRegistrationPrompt());
    }

    // if ( !Cookie.get('showed_welcome') ) this.launchWelcome();
  }

  onMenuClick(e) {
    e.preventDefault();
    this.context.router.push(e.currentTarget.pathname);
  }

  handleStorageChange(event) {
    if (event.key === 'janrain' || event.key === 'associate') {
      this.props.dispatch(handleConfirmRedirect(JSON.parse(event.newValue)));
      modal.clear();
      modal.add(SignUpModalView, {hideTitleBar:true, size:'medium', id:'signup-confirm'})
    }

    if (event.key === 'user') {
      let user = JSON.parse(event.newValue);
      if(!_.isObject(user)) {
        user = JSON.parse(user);
      }
      if(_.isObject(user)) {
        this.props.dispatch(authLoginUserSuccess(user));
        this.props.dispatch(fetchUserFavoritesSuccess(user.favorites));
        modal.clear();
      }
    }

    if (event.key === 'associate') {
      modal.clear()
      this.props.dispatch(authLoginUserSuccess(JSON.parse(event.newValue)));
      modal.add(ConfirmAssociationModalView, {hideTitleBar:true, size:'medium'});
    }

    if (event.key === 'rpx_error') {
      const errorData = JSON.parse(event.newValue);
      if (errorData) {
        const errorMessage = _.get(errorData, 'error.message', 'Couldn\'t authenticate');
        alert(`Error: ${errorMessage}`);
      }
    }
  }

  launchWelcome(e) {
    modal.clear();
    modal.add(WelcomeModal, {hideTitleBar:true, size:'large', id:'welcome-modal'});
  }

  onSideMenuClick (e) {
    if(e) {
      e.stopPropagation();
      e.preventDefault();
    }
    var sideNavWrapper = $('.side-nav-wrapper');
    var siteWrapper = $('.site-wrapper');

    if(!sideNavWrapper.hasClass('is-open')) {
      siteWrapper.on('click', this.closeMenuOnClick.bind(this))
    }

    // if ($('.side-nav').find('i').hasClass('icon-Hamburger_Navigation')) {
    //   $('.side-nav').find('i').addClass('icon-X_Close_Square').removeClass('icon-Hamburger_Navigation');
    // } else {
    //   $('.side-nav').find('i').addClass('icon-Hamburger_Navigation').removeClass('icon-X_Close_Square');
    // }

    //siteWrapper.toggleClass('is-open');
    sideNavWrapper.css('height', $(window).height()).toggleClass('is-open');
  }

  closeMenuOnClick(evt) {
    $('.site-wrapper').off('click');
    if(evt.target.className == 'icon-X_Close_Square') return;
    this.onSideMenuClick();
  }

  paneDidMount(node) {
    if (node) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    var $navGroup = $('.nav-group');
    var combinedNavHeight = ($navGroup.outerHeight() + $('.nav-wrapper').outerHeight());
    if ($navGroup.hasClass('is-locked')) {
      $navGroup.css('top', -combinedNavHeight);
      _.delay(function() {
        $navGroup.removeClass('is-locked');
        $('body').css('margin-top', '0');
      }, 300);
    }
  }

  openProfile(e, type) {
    e.preventDefault();
    modal.add(ProfileComponent, {title: '', size:'medium', hideTitleBar:true})
  }

  openSignup(e){
    e.preventDefault();
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-1036364696/z9nlCKOko5gBEJjXlu4D' });
    }
    modal.add(SignUpModalView, {title:'', size: 'medium', hideTitleBar:true, id: 'signup'});
  }

  openLogin(e){
    e.preventDefault();
    modal.add(LoginModalView, {title:'', size: 'medium', hideTitleBar:true, id:'login'});
  }
  closeModal() {
    this.setState({ notificationsModalOpen: false });
  }

  toggleModal() {
    const { notificationsModalOpen } = this.state;
    this.setState({ notificationsModalOpen: !notificationsModalOpen });
  }

  render () {
    let {
      isAuthenticated,
      opaqueBg,
      logo,
      notificationExceptions,
      commentToken,
    } = this.props;
    const { notificationsModalOpen } = this.state;

    const authBlock = (!isAuthenticated) ? (
      <div className="account-buttons-login d-flex justify-content-between  u-font-foundation-roman u-textSize-16">
        <TrackedButton
          type="link"
          to="/accounts/signup"
          onClick={(e) => { this.openSignup(e) }}
          title="Join"
          action="Click on 'Join' button"
        >
          <div className="join">Join</div>
        </TrackedButton>
        <Link to="/accounts/login" onClick={(e)=> {this.openLogin(e)}}><div className="login">Login</div></Link>
      </div>) : ('');
    const activeChannelId = this.props.activeChannelId;
    const conf = commentsConfig();

    return (
      <div className="nav-wrapper" ref={this.paneDidMount}>
        <div className={(opaqueBg) ? "nav-main bg-000 textColor-fff" : "nav-main bg-000-50 textColor-fff"}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="row align-items-center no-gutters">
                  <div className="col-auto side-columns">
                    <div className="brand-wrapper d-flex mr-auto align-items-center">
                      <a href="#" onClick={this.onSideMenuClick} className="side-nav">
                        <i className="icon-Hamburger_Navigation"></i>
                      </a>
                      <Link to="/livecams" className="nav-brand pr-2 pr-sm-0 ml-0 ml-md-3" onClick={this.onMenuClick}>
                        <i className="icon-ExploreLogo textColor-fff d-none mr-1"></i>
                        <img src={logo} className="explore-svg-logo" alt="Explore" />
                      </Link>
                      <span className="search-label text-uppercase u-font-foundation-light u-textSize-18 header-breadcrumbs">
                      <MediaQuery query="(max-width: 767px)">
                        {(isAuthenticated) ? 'Favorites' : this.props.sectionName}
                      </MediaQuery>
                      <MediaQuery query="(min-width: 768px)">
                        {this.props.sectionName}
                      </MediaQuery>
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div className="container-fluid">
                    <div className="row justify-content-center">
                      {!this.props.standalone && (
                        <div className="col-12 col-md-8 col-xxl-6">
                          <SearchView />
                        </div>
                      )}
                    </div>
                    </div>
                  </div>
                  <div className="col-auto ml-auto side-columns">
                    <div className="container-fluid">
                      <div className="row justify-content-end">
                        <div className="col-auto">
                          <div id="navigation-buttons" className="navigation-wrapper align-items-center d-flex">
                        <div className="account-buttons-wrap justify-content-between align-items-center u-font-foundation-roman u-textSize-16">
                          {authBlock}
                        </div>
                        {isAuthenticated ? (
                          <Fragment>
                              <div className="search-wrapper">
                                <NotificationEmbed
                                  config={conf}
                                  token={commentToken}
                                  dropdown
                                  except={notificationExceptions}
                                  onSettingsClick={this.toggleModal}
                                />
                              </div>
                              <UserMenu {...this.props} />
                              <NotificationSettingsModal
                                isOpen={notificationsModalOpen}
                                onClose={this.closeModal}
                                id="hd"
                              />
                          </Fragment>
                          ) : null}
                      </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userName: state.auth.userName,
    commentToken: state.auth.commentToken,
    displayName: state.auth.displayName,
    userId: state.auth.userId,
    avatarUri: state.auth.avatarUri,
    statusText: state.auth.statusText,
    isAuthenticated: state.auth.isAuthenticated,
    isSuperuser: state.auth.isSuperuser,
    isStaff: state.auth.isStaff,
    token: state.auth.token,
    resetToken: state.auth.resetPassword.token,
    activeChannelId: _.get(state, 'currentItem.data.channel.id', null),
    sectionName: state.globalConfig.currentSection || ownProps.sectionName,
    opaqueBg: ownProps.opaqueBg,
    promptRegistration: state.auth.promptRegistration,
    livecamClicks: state.currentItem.livecamClicks,
    logo: state.globalConfig.logo,
    notificationExceptions: state.uiPreferences.notificationExceptions || [],
  };
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
Header.contextTypes = contextTypes;

export default connect(mapStateToProps)(Header);
